import { useEffect, useState } from 'react'
import { SELECTION_CHANGE_COMMAND, type LexicalEditor } from 'lexical'
import type { ToolbarState } from '@/features/contract/types/toolbar.ts'
import { readToolbarState } from '@/features/contract/utils/toolbar.ts'

export function useToolbarState(editor: LexicalEditor) {
  const [state, setState] = useState<ToolbarState>(() => readToolbarState(editor))

  useEffect(() => {
    const update = () => setState(readToolbarState(editor))
    return editor.registerCommand(
      SELECTION_CHANGE_COMMAND,
      () => {
        update()
        return false
      },
      0
    )
  }, [editor])

  useEffect(() => editor.registerUpdateListener(() => setState(readToolbarState(editor))), [editor])

  return state
}
